export { default } from "@peekops/peek-extensions-framework/vite/require-shim";
